<!-- 标签定义 从表 -->
<template>
<div>
  <Table
    ref="table"
    :loadObj='{
      extendTreeType:this.$route.query.IS_TREE==1?2:0,
    }'
    :option="{
      extendTreeType:this.$route.query.IS_TREE,
    }"
    :colObj='{
      opId:"3122",
      name:"标签明细",
      parentId:"LABELDEF_ID",
      parentName:"标签定义",
      parentPath:"/system/labelDefine",
      dataClass:2,
      isTree:isTree,
      addParams:{
        LABELDEF_ID:this.$route.query.LABELDEF_ID,
      },
      col:[],
    }'
  >
  </Table>
</div>
</template>
<script>
import Table from '@/components/table/treeOrTableSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
      isTree:null,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
  },
  activated(){
    this.isTree=this.$route.query.IS_TREE==1;
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>